<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Хичээл засах</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <input v-model.trim="lesson.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Хичээлийн нэр">
                    </div>
                    <div class="form-group">
                      <textarea v-model.trim="lesson.description" type="text" class="form-control" id="exampleInputPassword" placeholder="Дэлгэрэнгүй" rows="10"/>
                    </div>
                    <div class="form-group">
                      <input v-model.trim="lesson.profession" type="text" class="form-control"  placeholder="Албан тушаал">
                    </div>
                     <div class="row">
                       <div class="col form-group">
                         <label>Xичээлийн код</label>
                        <input readonly="readonly" v-model.trim="lesson.lectureCode" type="text" class="form-control"  placeholder="Lecture Code">
                       </div>
                       <div class="col form-group">
                         <label>Кредит</label>
                        <input v-model.trim="lesson.credit" type="number" class="form-control"  placeholder="Кредит">
                      </div>
                     </div>
                    <div class="row">
                      <div class="col form-group">
                        <input v-model.trim="lesson.teacherFirstName" type="text" class="form-control"  placeholder="Багшийн нэр">
                      </div>
                      <div class="col form-group">
                        <input v-model.trim="lesson.teacherLastName" type="text" class="form-control"  placeholder="Багшийн овог">
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col form-group">
                        
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary" type="button" v-for="type in lessonTypes"
                              v-bind:class="[lesson.types!=null && lesson.types.length>0 && lesson.types.includes(type) ? 'btn-success text-white' : '']"
                              @click="addType(type)"
                            >{{type}}

                            </button>

                          </div>
                        </div>

                      </div>
                    </div> -->
                    <!-- <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Семестер:</label>
                        <select class="form-control" v-model="semester">
                          <option v-for="semester in semesters" v-bind:key="'semester-'+semester.id" v-bind:value="semester.id">{{semester.data().title}}</option>
                        </select>
                      </div>
                    </div> -->
                    <div class="form-group" >
                      <div class="">
                        <input type="checkbox"  id="blockcheck" v-model="lesson.isBlock">
                        <label for="blockcheck">Блок хичээл<span class="text-info"> /Олон хөтөлбөрт ордог хичээл/</span></label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Сургууль</label>
                          <select class="form-control" v-model="school" @change="schoolChanged">
                            <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="school!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Тэнхим</label>
                          <select class="form-control" v-model="department" >
                            <option v-for="(dep, index) in school.departments" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="department!=null && (lesson.isBlock==null || (lesson.isBlock!=null && lesson.isBlock==false))">
                      <label for="exampleFormControlSelect1">Хөтөлбөр</label>
                      <select class="form-control" v-model="program" >
                        <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{index+1}}.  {{pro.name}}</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="requirement" type="text" class="form-control" placeholder="Хичээлийн шаардлага"/>
                        </div>
                        
                        <div class="col col-2 ">
                          <div @click="addRequirement" class="btn btn-success btn-block">
                          нэмэх
                          </div>
                        </div>
                      </div>
                      <ul  v-if="lesson.requirements!=null && lesson.requirements.length>0">
                        <li  v-for="(include, index) in lesson.requirements" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.requirements)"></i>
                        </li>
                      </ul>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="result" type="text" class="form-control" placeholder="Зорилго"/>
                        </div>
                        
                        <div class="col col-2 ">
                          <div @click="addResult" class="btn btn-success btn-block">
                            нэмэх
                          </div>
                        </div>
                      </div>
                      <ul  v-if="lesson.results!=null && lesson.results.length>0">
                        <li  v-for="(include,index) in lesson.results" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.results)"></i>
                        </li>
                      </ul>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="whatlearned" type="text" class="form-control" placeholder="Эзэмшүүлэх мэдлэг"/>
                        </div>
                        <div class="col col-2 ">
                          <div @click="addLearned" class="btn btn-success btn-block">
                            нэмэх
                          </div>
                        </div>
                      </div>
                      <ul v-if="lesson.whatlearned!=null && lesson.whatlearned.length>0">
                        <li v-for="(include, index) in lesson.whatlearned" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.whatlearned)"></i>
                        </li>
                      </ul>
                    </div>

                     <div class="form-group">
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="handlagaText" type="text" class="form-control" placeholder="Хичээлээр эзэмшүүлэх хувь хүний ур чадвар, хандлага"/>
                        </div>
                        
                        <div class="col col-2 ">
                          <div @click="addHandlaga" class="btn btn-success btn-block">
                          нэмэх
                          </div>
                        </div>
                      </div>
                      <ul  v-if="lesson.handlaga!=null && lesson.handlaga.length>0">
                        <li  v-for="(include, index) in lesson.handlaga" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.handlaga)"></i>
                        </li>
                      </ul>
                    </div>
                    <!-- <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input type="checkbox" class="custom-control-input" id="customCheck">
                        <label class="custom-control-label" for="customCheck">Remember Me</label>
                      </div>
                    </div> -->
                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
    name: "LessonEdit",
    data() {
        return {
            lesson: {
                name: '',
                description: '',
                lectureCode:'',
                profession:"",
                requirements:[],
                results:[],
                whatlearned:[],
                teacherFirstName:'',
                teacherLastName:'',
                // skills:[],
                handlaga:[],
                semester:null,
                credit:null,
                types:[],
                isBlock:false
               
            },
            performingRequest:false,
            requirement:'',
            result:'',
            whatlearned:'',
            // skill:'',
            handlagaText:'',
            schools:[],
            school:null,
            department:null,
            program:null,
            semesters:[],
            semester:null,
            lessonTypes:[
              "Ерөнхий эрдэм",
              "Мэргэжлийн",
              "Мэргэжлийн суурь",
              "Сонгох",
              "Магистр",
              "Доктор"
            ],
            setSchool:false,
            setDepartment:false,
            setProgram:false
        };
    },
    methods: {
        save() {
            this.performingRequest = true
            if(this.lesson!=null && this.lesson.name!='' && this.semester!=null && this.semester!=''){
                // this.lesson.userId=this.$store.getters.currentUser.uid;
                // this.lesson.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                // this.lesson.createdAt=new Date()
                // this.lesson.school=null;
                // this.lesson.department=null;
                // this.lesson.program=null;
                // if(this.school!=null){
                //   this.lesson.school=fb.db.collection("schools").doc(this.school.id);
                //   if(this.setSchool==false){
                //     fb.db.collection("schools").doc(this.school.id).update({
                //       'numberOfLessons': fb.firestore.FieldValue.increment(1)
                //     });
                //   }
                // }
                // if(this.school!=null && this.department!=null){
                //   this.lesson.department=fb.db.collection("schools").doc(this.school.id).collection("departments").doc(this.department.id);
                //   if(this.setDepartment==false){
                //     fb.db.collection("schools").doc(this.school.id).collection("departments").doc(this.department.id).update({
                //       'numberOfLessons': fb.firestore.FieldValue.increment(1)
                //     });
                //   }
                // }
                if(this.school!=null && this.department!=null && this.program!=null){
                  this.lesson.program=fb.db.collection("schools").doc(this.school.id).collection("departments").doc(this.department.id).collection("programs").doc(this.program.id);
                  if(this.setProgram==false){
                    fb.db.collection("schools").doc(this.school.id).collection("departments").doc(this.department.id).collection("programs").doc(this.program.id).update({
                      'numberOfLessons': fb.firestore.FieldValue.increment(1)
                    });
                  }
                }
                // this.lesson.program=this.program.ref
                // if(this.semester!=null){
                //   this.lesson.semester=fb.db.collection("semester").doc(this.semester);
                // }
                fb.db.collection("lessons").doc(this.lessonId).update(this.lesson);
                this.$router.back();
            }
            else{
              alert("Та хичээлийнхээ нэр болон улирал оруулна уу");
            }
        },
        setLesson(){
          this.lesson={
                name: '',
                description: '',
                included:[],
                lectureCode:'',
                profession:"",
                requirements:[],
                results:[],
                whatlearned:[],
                skills:[],
                handlaga:[],
                credit:null,
                types:[]

            }
        },
        addIncluded(){
          if(this.included!=null && this.included!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.included.push(this.included)
            this.included=''
          }
        },
        addRequirement(){
          if(this.requirement!=null && this.requirement!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.requirements.push(this.requirement)
            this.requirement=''
          }
        },
        addResult(){
          if(this.result!=null && this.result!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.results.push(this.result)
            this.result=''
          }
        },
        addLearned(){
          if(this.whatlearned!=null && this.whatlearned!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.whatlearned.push(this.whatlearned)
            this.whatlearned=''
          }
        },
        addSkill(){
          if(this.skill!=null && this.skill!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.skills.push(this.skill)
            this.skill=''
          }
        },
        addHandlaga(){
          if(this.handlagaText!=null && this.handlagaText!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.handlaga.push(this.handlagaText)
            this.handlagaText=''
          }
        },
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },
        _getSchools(){
          fb.db.collection("schools")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                let object=schoolData.data();
                object.id=schoolData.id;

                this._getDepartments(schoolData.id, object);
                this.schools.push(object);
              });
              if(this.lesson.school!=null){
                  this.schools.forEach(sc=>{
                    if(sc.id==this.lesson.school.id)
                      {this.school=sc;

                      }
                  })
                }
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getDepartments(schoolId, schoolData){
         
          fb.db.collection("schools").doc(schoolId).collection("departments")
          .get()
          .then(querySnapshot=> {
              let deps=[]
              querySnapshot.forEach(depdata=> {
                 let object=depdata.data();
                object.id=depdata.id;
                object.programs=[];
                this._getPros(object, depdata.ref)
                deps.push(object)
              });
              schoolData.departments=deps;
               if(this.lesson.department!=null && this.school.departments){
                  this.school.departments.forEach(sc=>{
                    if(sc.id==this.lesson.department.id)
                      {this.department=sc;

                      }
                  })
                }
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getPros(depdata, depRef){
          depRef.collection("programs")
          .get()
          .then(querySnapshot=> {
            let pros=[];
              querySnapshot.forEach(prodata=> {
                let object=prodata.data();
                object.id=prodata.id;
                pros.push(object);
              });
              depdata.programs=pros;
              if(this.lesson.program!=null && this.department.programs){
                  this.department.programs.forEach(sc=>{
                    if(sc.id==this.lesson.program.id)
                      {this.program=sc;

                      }
                  })
                }
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        schoolChanged(){
          this.department=null
          this.program=null
        },
        _getQA(){
          if(this.lessonId!=null && this.lessonId!=''){
            var docRef=fb.db.collection("lessons").doc(this.lessonId).get().then(doc=> {
                this.lesson=doc.data()
                this.lesson.id=doc.id;
                if(this.lesson.semester!=null)
                  this.semester=this.lesson.semester.id;
                if(this.lesson.school!=null && this.lesson.school!=undefined)
                  this.setSchool=true;
                if(this.lesson.department!=null && this.lesson.department!=undefined)
                  this.setDepartment=true;
                if(this.lesson.program!=null && this.lesson.program!=undefined)
                  this.setProgram=true;
                if(!this.lesson.requirements)
                  this.lesson.requirements=[];
                if(!this.lesson.results)
                  this.lesson.results=[];
                if(!this.lesson.whatlearned)
                  this.lesson.whatlearned=[];
                if(!this.lesson.handlaga)
                  this.lesson.handlaga=[];

            }).catch(function(error) {
                console.log("Error getting document:", error);
            });

          }
        },
        async _getSemesters(){
          var semesters=await fb.db.collection("semester").get();
          this.semesters=semesters.docs;

        },
         addType(type){
          if(this.lesson.types==null || this.lesson.types==undefined)
            this.lesson.types=[];
          if(!this.lesson.types.includes(type))
            this.lesson.types.push(type);
          else
            this.lesson.types.splice(this.lesson.types.indexOf(type), 1); 
        }
        
    }, 
    props: {
      lessonId: { 
        required: true,
      }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA()
        this._getSchools();
        this._getSemesters();
        
        
            
    },
  
};
</script>

